
export const data = [
    {
        id: 1,
        userID: '#HT001',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 2,
        userID: '#HT002',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com', 
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 3,
        userID: '#HT003',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com', 
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 4,
        userID: '#HT004',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com', 
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 5,
        userID: '#HT005',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com', 
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 6,
        userID: '#HT006',
        employeeName: 'John David',
        jobRoleName: 'General Manager',
        hotelName: 'Radisson Blu',
        contactNumber: '+65 987 654 321',
        emailAddress: 'raj198672@gmail.com', 
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    }

]


export const cityList = [
    {
        options: [
            { label: "Select City", value: "Select City" },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]
export const approledata = [
    {
        options: [
           
            { label: "Primary", value: "1" },
            { label: "Secondary", value: "2" },
           
        ]
    }
]
export const countryList = [
    {
        options: [
            { label: "Select Country", value: "Select Country" },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]